<template>
  <div v-if="MENSAGEM.length > 0">
    <v-menu offset-y open-on-hover open-delay="1000" :max-width="600">
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="cursor-help text-truncate py-1 border-cyan font-14">
          <v-icon size="18" left class="pl-1" color="cyan">mdi-information</v-icon>
          <span v-text="MENSAGEM" />
        </div>
      </template>

      <div
        class="bg-white pa-5 font-14 text-justify"
        v-html="MENSAGEM.replaceAll('-', '<br /><br />')"
      />
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "MensagemTopoTabela",
  props: ['pedido'],
  computed: {
    MENSAGEM () {
      if (!this.pedido) {
        return '';
      }

      const {id_capa_lista, data_validade_lista} = this.pedido;
      let txt = '';

      if (id_capa_lista > 0) {
        txt = `Lista de preços identificada pelo nº ${id_capa_lista}, vinculada a este pedido de compra, válida até ${data_validade_lista}.`
      }

      return txt;
    }
  }
}
</script>

<style scoped>
.border-cyan {
  border-left: 8px solid #10e8e8;
}
</style>
